import React from 'react';

type Phone15FrameProps = {
  children?: React.ReactNode;
  className?: string;
};

/** Invisible safe-area inset — hero bleeds through; no rendered status bar chrome. */
export const PHONE_SAFE_AREA_TOP = 48;

/**
 * Minimal iPhone 15 device frame. Screen content goes inside `children`.
 */
const Phone15Frame: React.FC<Phone15FrameProps> = ({ children, className = '' }) => (
  <div className={`mx-auto w-full max-w-[260px] ${className}`}>
    <div className="rounded-[48px] bg-[#1c1c1e] p-[10px] shadow-[0_24px_48px_rgba(42,15,42,0.18)]">
      <div className="relative aspect-[9/19.5] overflow-hidden rounded-[38px] bg-[#fcf7fa]">
        <div
          className="pointer-events-none absolute left-1/2 top-[10px] z-30 h-[26px] w-[88px] -translate-x-1/2 rounded-full bg-[#1c1c1e]"
          aria-hidden
        />

        <div className="absolute inset-0 overflow-y-auto overflow-x-hidden bg-[#fcf7fa] scrollbar-hide">
          {children}
        </div>
      </div>
    </div>
  </div>
);

export default Phone15Frame;
